<template>
  <div class="container min-h-screen pt-24">
    <div class="py-4 mb-3 border-b border-primary">
      <h1 class="text-xl font-bold">Frequently Asked Questions</h1>
      <p>
        Don't see your question? Send us a message and a VIVA rep will be in contact with you as
        soon as possible!
      </p>
    </div>
    <VueFaqAccordion :items="myItems" activeColor="#559FE3" class="w-full" />
  </div>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion'

export default {
  components: {
    VueFaqAccordion
  },
  data() {
    return {
      myItems: [
        {
          title: 'How do I apply for a loan? Can you describe the application process? ',
          value:
            'The online application is easy and takes about 5 minutes. Go to our website: www.viva-finance.com and click “Apply Now” in the top right corner of the page. You will need to select your employer from the drop down and verify your work email. It will then ask you to provide some personal information, some employment information, and lastly to link the bank account where you would like to have your funds deposited. Once you complete the application, we will review and verify your information within 24 hours. If we need any additional information, we will request it through email. Once we have everything we need, we will send you an offer email that will contain details regarding your loan amount, APR, payment amounts, and first payment date. If you would like to accept the offer, follow the steps in the offer email to receive your final loan contract. Once you sign your contract, the funds will be deposited to your linked bank account in 1 – 2 business days!',
          category: 'General Questions'
        },
        {
          title:
            'I received an email from my employer about your loans. Can you please tell me a little bit more about the program?',
          value: 'We offer personal loans up to $10,000 paid back over a 24-month term.',
          category: 'General Questions'
        },
        {
          title: 'What are the requirements for being approved for a VIVA Finance loan?',
          value:
            'In order to be eligible for one of our loans you must be at least 18 years old, have worked full time with your eligible employer for at least one year consecutively, and not have a current outstanding bankruptcy. We currently are unable to lend to active military service members or spouses. Our applications are evaluated on several factors, including details like the length of your employment, credit history, and income.',
          category: 'Loan Approval'
        },
        {
          title: 'How long does it take to receive approval?',
          value:
            'You will receive a decision within 1 business day of completing your application and providing all necessary verification.',
          category: 'Loan Approval'
        },
        {
          title: 'How long does it take to receive funds?',
          value:
            'Once you sign your final loan contract online, your funds will be deposited directly into your bank account within 1 – 2 business days.',
          category: 'Loan Approval'
        },
        {
          title: 'How much can I borrow?',
          value:
            'We offer unsecured personal loans up to $10,000. The amount you can borrow is largely determined by your take- home pay. Ensuring that our borrowers’ monthly repayments are affordable is one of our top priorities!',
          category: 'Loan Approval'
        },
        {
          title: 'How do the repayments work?',
          value:
            'We receive loan repayments through a direct deposit setup with your payroll. This means that every time you receive a paycheck from your employer a small amount of that paycheck will come directly to VIVA for the repayment of your loan.',
          category: 'Payments And Credit Reporting'
        },
        {
          title: 'Do you report to credit bureaus?',
          value:
            'Yes, VIVA reports to all three credit bureaus. We cannot guarantee improvement in your credit score, but our automatic repayment process is designed to encourage on-time payments and build your score over time!',
          category: 'Payments And Credit Reporting'
        },
        {
          title: 'If I want to pay off early, can I do that?',
          value:
            'Yes! There are no penalties for early repayment. You are always welcome to make additional payments at any time or pay off your full loan balance early! To make an additional payment, you can give us a call or visit the “My Loan” tab on your VIVA dashboard.',
          category: 'Payments And Credit Reporting'
        },
        {
          title: 'I need to refinance my loan. Is this possible?',
          value:
            'Currently, VIVA does not offer refinancing or allow for additional funds to be added on to an existing loan. You would be able to apply for another loan after your current loan is paid in full.',
          category: 'Payments And Credit Reporting'
        }
      ]
    }
  }
}
</script>
